module.exports = __webpack_public_path__ + "img/stock1.1da292f6.png";